// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"OTWCQQOpgrOjEJNzw2eU4","checked":"_3OIo5NwDgSgXhvTXX3HyJB","red":"_3ROYy5oWj9UuiVOAEKFm6","readonly":"_3jVPslcM0F-rpPqVhuqFmd"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/fields/Checkbox.css
// module id = 309
// module chunks = 0